import Storage, {StorageChange, StorageItems, StorageKeys} from "./index.js";

/**
 * Implements local storage for extensions. Both background scripts and content
 * scripts can access the storage API.
 */
export default class ExtLocalStorage extends Storage {
	get(keys: StorageKeys | StorageItems): Promise<StorageItems> {
		return chrome.storage.local.get(keys);
	}

	set(items: StorageItems) {
		return chrome.storage.local.set(items);
	}

	remove(keys: StorageKeys) {
		return chrome.storage.local.remove(keys ?? []);
	}

	clear() {
		return chrome.storage.local.clear();
	}

	listen(callback: (changes: StorageChange) => void) {
		chrome.storage.onChanged.addListener((changes, namespace) => {
			if (namespace !== "local")
				return;

			callback(changes);
		});
	}
}
